var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#E5FAEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.75C19.2352 13.75 13.75 19.2352 13.75 26C13.75 32.7648 19.2352 38.25 26 38.25C32.7648 38.25 38.25 32.7648 38.25 26C38.25 19.2352 32.7648 13.75 26 13.75ZM31.0449 23.4215L26.1777 30.148C26.1576 30.176 26.1311 30.1988 26.1004 30.2145C26.0698 30.2302 26.0358 30.2383 26.0014 30.2383C25.9669 30.2383 25.933 30.2302 25.9023 30.2145C25.8716 30.1988 25.8451 30.176 25.825 30.148L20.9578 23.4215C20.8539 23.2766 20.9578 23.0742 21.1355 23.0742H22.418C22.6969 23.0742 22.9621 23.2082 23.1262 23.4352L26 27.4109L28.8766 23.4352C29.0406 23.2082 29.3031 23.0742 29.5848 23.0742H30.8672C31.0449 23.0742 31.1488 23.2766 31.0449 23.4215Z",
    fill: "#0D9F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.1ace2f68deb76bc427cb0221cf19207c.svg";
export { ForwardRef as ReactComponent };